
export const TypesUtils = {

  getType: (obj) => {
    return Object.prototype.toString.call(obj);
  },

  isType: (obj, type) => {
    return TypesUtils.getType(obj) === '[object ' + type + ']';
  },

  isString: (obj) => {
    return TypesUtils.isType (obj, 'String');
  },

  isObject: (obj) => {
    return TypesUtils.isType (obj, 'Object');
  }
};



// WEBPACK FOOTER //
// ./src/utils/TypesUtils.js